// extracted by mini-css-extract-plugin
export default {"container":"PersonPhoto_container__mey+Z","photo":"PersonPhoto_photo__iMQWl"};